import { red } from '@material-ui/core/colors';
import { unstable_createMuiStrictModeTheme } from '@material-ui/core/styles';

// A custom theme for this app
const theme = unstable_createMuiStrictModeTheme({
  palette: {
    primary: {
      main: '#556cd6',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
  },
  overrides:{
    MuiSlider: {
      "colorPrimary": {
        "&$disabled": {
          "color": "green"
        }
      },
      "colorSecondary": {
        "&$disabled": {
          "color": "red"
        }
      }
    }
  }
});

export default theme;
